import axios, { AxiosError } from "axios";

const API_URL = import.meta.env.VITE_API_URL as string;
const WORKER_URL = import.meta.env.VITE_WORKER_URL as string;
const TOKEN_KEY = "maestro_auth_token";

// All requests include the auth cookie automatically thanks to withCredentials.
export const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  timeout: 15_000,
});

// Worker client has a much longer timeout (pipeline can take minutes).
// Uses Authorization: Bearer (token injected per-call, see api/clearance.ts).
export const worker = axios.create({
  baseURL: WORKER_URL,
  timeout: 15 * 60 * 1000,
});

// Shared 401 handler: clear token and bounce to the landing page (/).
// Skips /auth/me since that endpoint is used to probe the session on first
// load — a 401 there is expected and handled in auth/api.ts.
function install401Handler(client: typeof api) {
  client.interceptors.response.use(
    (r) => r,
    (err: AxiosError) => {
      const url = err.config?.url || "";
      if (err.response?.status === 401 && !url.endsWith("/auth/me")) {
        sessionStorage.removeItem(TOKEN_KEY);
        if (window.location.pathname !== "/") {
          window.location.assign("/");
        }
      }
      return Promise.reject(err);
    },
  );
}

install401Handler(api);
install401Handler(worker);
